import type { Data } from '@repo/strapi'
import AppLink from '@/components/elementary/AppLink'
import { Paragraph } from '@/components/typography/Paragraph'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/styles'
import { NAVBAR_TEST_IDS } from '@/lib/test-ids'
import styles from './MobileMenu.module.css'

interface CTAButtonsProps {
	readonly logInLink?: Data.Component<'utilities.link'> | null
	readonly primaryButtons?: Data.Component<'utilities.link'>[] | null
	readonly dropdownItem?: Data.Component<'layout-utilities.dropdown-item'> | null
	readonly className?: string
	readonly navContext?: 'menu-items' | 'menu-content'
	onDropdownClick?: () => void
}

export const CTAButtons = ({
	logInLink,
	primaryButtons,
	dropdownItem,
	className,
	navContext = 'menu-items',
	onDropdownClick,
}: CTAButtonsProps) => {
	return (
		<div className={cn('flex gap-8 flex-col w-full pb-8', className)}>
			{/* Login */}
			{logInLink?.href && logInLink?.label ? (
				<div className={cn('w-full border-b border-neutral-light-500 py-8')}>
					<AppLink
						href={logInLink.href}
						openExternalInNewTab={!!logInLink.newTab}
						data-test-id={NAVBAR_TEST_IDS.LOGIN_BUTTON}
					>
						<Paragraph
							fontSize={navContext === 'menu-items' ? 'displaySmall' : 'headingMedium'}
							className={cn('text-inherit', styles['menu-link'])}
						>
							{logInLink.label}
						</Paragraph>
					</AppLink>
					<div className="mx-4 w-px bg-neutral-light-500 h-6 hidden" />
				</div>
			) : null}

			{/* Trial Signup */}
			<div className="flex flex-col gap-3">
				{primaryButtons && primaryButtons.length > 0
					? primaryButtons.map((primaryButton) =>
							primaryButton.href ? (
								<AppLink
									key={primaryButton.id}
									size="large"
									variant="primary"
									href={primaryButton.href}
									openExternalInNewTab={!!primaryButton.newTab}
									data-test-id={NAVBAR_TEST_IDS.PRIMARY_BUTTON}
									className="w-full"
								>
									{primaryButton.label}
								</AppLink>
							) : null,
						)
					: null}

				{dropdownItem ? (
					<Button variant="secondary" size="large" className="w-full" onClick={onDropdownClick}>
						{dropdownItem.label}
					</Button>
				) : null}
			</div>
		</div>
	)
}
